var map = {
  "./chess/blackBreak/10.png": "9583",
  "./chess/blackBreak/11.png": "6294",
  "./chess/blackBreak/12.png": "269",
  "./chess/blackBreak/13.png": "6372",
  "./chess/blackBreak/14.png": "6587",
  "./chess/blackBreak/15.png": "5410",
  "./chess/blackBreak/16.png": "6377",
  "./chess/blackBreak/17.png": "8256",
  "./chess/blackBreak/18.png": "9351",
  "./chess/blackBreak/19.png": "510",
  "./chess/blackBreak/20.png": "7582",
  "./chess/blackBreak/6.png": "1872",
  "./chess/blackBreak/7.png": "8777",
  "./chess/blackBreak/8.png": "9390",
  "./chess/blackBreak/9.png": "2407",
  "./chess/blackBurn/0.png": "6614",
  "./chess/blackBurn/1.png": "8012",
  "./chess/blackBurn/10.png": "63",
  "./chess/blackBurn/11.png": "3734",
  "./chess/blackBurn/12.png": "5357",
  "./chess/blackBurn/13.png": "5412",
  "./chess/blackBurn/14.png": "7067",
  "./chess/blackBurn/15.png": "2850",
  "./chess/blackBurn/16.png": "3561",
  "./chess/blackBurn/17.png": "8736",
  "./chess/blackBurn/18.png": "2967",
  "./chess/blackBurn/19.png": "4654",
  "./chess/blackBurn/2.png": "1140",
  "./chess/blackBurn/20.png": "686",
  "./chess/blackBurn/3.png": "4173",
  "./chess/blackBurn/4.png": "9922",
  "./chess/blackBurn/5.png": "1051",
  "./chess/blackBurn/6.png": "9760",
  "./chess/blackBurn/7.png": "6009",
  "./chess/blackBurn/8.png": "4094",
  "./chess/blackBurn/9.png": "9671",
  "./chess/whiteBreak/10.png": "2673",
  "./chess/whiteBreak/11.png": "1544",
  "./chess/whiteBreak/12.png": "7299",
  "./chess/whiteBreak/13.png": "2090",
  "./chess/whiteBreak/14.png": "8965",
  "./chess/whiteBreak/15.png": "6076",
  "./chess/whiteBreak/16.png": "4183",
  "./chess/whiteBreak/17.png": "4958",
  "./chess/whiteBreak/18.png": "521",
  "./chess/whiteBreak/19.png": "4272",
  "./chess/whiteBreak/20.png": "9100",
  "./chess/whiteBreak/6.png": "1034",
  "./chess/whiteBreak/7.png": "9891",
  "./chess/whiteBreak/8.png": "4596",
  "./chess/whiteBreak/9.png": "7629",
  "./chess/whiteBurn/0.png": "9416",
  "./chess/whiteBurn/1.png": "545",
  "./chess/whiteBurn/10.png": "8309",
  "./chess/whiteBurn/11.png": "6684",
  "./chess/whiteBurn/12.png": "7367",
  "./chess/whiteBurn/13.png": "1582",
  "./chess/whiteBurn/14.png": "6145",
  "./chess/whiteBurn/15.png": "7752",
  "./chess/whiteBurn/16.png": "9731",
  "./chess/whiteBurn/17.png": "9898",
  "./chess/whiteBurn/18.png": "9133",
  "./chess/whiteBurn/19.png": "9540",
  "./chess/whiteBurn/2.png": "9466",
  "./chess/whiteBurn/20.png": "9744",
  "./chess/whiteBurn/3.png": "5027",
  "./chess/whiteBurn/4.png": "7628",
  "./chess/whiteBurn/5.png": "9893",
  "./chess/whiteBurn/6.png": "2062",
  "./chess/whiteBurn/7.png": "1559",
  "./chess/whiteBurn/8.png": "5200",
  "./chess/whiteBurn/9.png": "1449",
  "./common/address_modal_bg.png": "8230",
  "./common/address_modal_title.png": "1597",
  "./common/bamboo_left.png": "8768",
  "./common/bamboo_right.png": "197",
  "./common/bg_main.jpg": "9415",
  "./common/btn_rule.png": "8447",
  "./common/close.png": "2552",
  "./common/main_share_modal_bg.jpg": "2053",
  "./common/modal_bg.png": "3061",
  "./common/modal_cancel.png": "4777",
  "./common/prize_A.png": "6112",
  "./common/reward_bg.png": "1157",
  "./common/reward_error.png": "644",
  "./common/reward_name_bg.png": "5723",
  "./common/rope.png": "3922",
  "./common/rule_modal_bg.png": "6922",
  "./common/winner_nian.png": "1610",
  "./common/winner_wang.png": "7313",
  "./dialog/dialog_bg.png": "3797",
  "./dialog/nian_awkward.png": "9917",
  "./dialog/nian_awkward_guide.png": "6188",
  "./dialog/nian_guide.png": "592",
  "./dialog/nian_name.png": "9843",
  "./dialog/nian_normal.png": "9116",
  "./dialog/nian_smile.png": "8756",
  "./dialog/nian_smile_guide.png": "3449",
  "./dialog/skill_tip_bg.png": "3662",
  "./dialog/wang_black.png": "4762",
  "./dialog/wang_close.png": "1863",
  "./dialog/wang_close_guide.png": "1841",
  "./dialog/wang_guide.png": "2387",
  "./dialog/wang_name.png": "5458",
  "./dialog/wang_normal.png": "2906",
  "./dialog/wang_sigh.png": "7158",
  "./game/black_chess.png": "7709",
  "./game/black_chess_box.png": "2539",
  "./game/board.png": "4785",
  "./game/capture_black_top.png": "335",
  "./game/capture_bottom.png": "3342",
  "./game/capture_white_top.png": "6521",
  "./game/divider.png": "4482",
  "./game/icon.svg": "6709",
  "./game/info_container.png": "9577",
  "./game/restart_bottom.png": "9160",
  "./game/restart_top.png": "3100",
  "./game/revoke_bottom.png": "2177",
  "./game/revoke_top.png": "9435",
  "./game/share_bottom.png": "2676",
  "./game/share_top.png": "344",
  "./game/skill_title.png": "8033",
  "./game/white_chess.png": "5303",
  "./game/white_chess_box.png": "4089",
  "./game/winner_bg.png": "1864",
  "./game/winner_text.svg": "7483",
  "./game/winner_title.png": "8683",
  "./icons/header_gift.png": "6591",
  "./icons/header_home.png": "9936",
  "./icons/header_login_exit.png": "5039",
  "./icons/header_login_switch.png": "1995",
  "./icons/header_logined.png": "7109",
  "./icons/header_return.png": "2115",
  "./icons/header_sound_off.png": "5498",
  "./icons/header_sound_on.png": "1558",
  "./icons/header_user.png": "7320",
  "./loading/bg.jpg": "7600",
  "./loading/bg_mask.png": "4801",
  "./loading/chess_board.png": "8140",
  "./loading/deco_lt.png": "3547",
  "./loading/deco_rt.png": "769",
  "./loading/logo.png": "4924",
  "./loading/logo_single.png": "6857",
  "./loading/now_loading.png": "7792",
  "./loading/piece_black.png": "7499",
  "./loading/piece_white.png": "5845",
  "./loading/progress_bg.png": "6072",
  "./loading/progress_icon.png": "3530",
  "./loading/role1.png": "4800",
  "./loading/role2.png": "3131",
  "./loading/sub_title.png": "7696",
  "./loading/title.png": "2567",
  "./loading/title_bg.png": "4237",
  "./loading/top.png": "2804",
  "./multi/top_layer.png": "2533",
  "./recall/arrow.png": "1407",
  "./recall/avatar-bg.png": "9797",
  "./recall/award-bg.png": "3415",
  "./recall/backspace.svg": "9398",
  "./recall/bg.jpg": "4811",
  "./recall/bg_mask.png": "8088",
  "./recall/btn_bg_copy.png": "598",
  "./recall/btn_recall.png": "3698",
  "./recall/cg/share_content_1.jpg": "2778",
  "./recall/cg/share_content_2.jpg": "9029",
  "./recall/cg/share_content_3.jpg": "1160",
  "./recall/cg/share_content_4.jpg": "4603",
  "./recall/cg/share_content_4.png": "3187",
  "./recall/chance.png": "7966",
  "./recall/chance_B.png": "1633",
  "./recall/common-modal-bg.png": "1606",
  "./recall/content_title_bg.png": "9380",
  "./recall/draw_cnt_bg.png": "1504",
  "./recall/frame-1.png": "9593",
  "./recall/gd_card.png": "1754",
  "./recall/hcy.png": "2016",
  "./recall/home_btn.png": "5338",
  "./recall/icon-pool-active.png": "9483",
  "./recall/icon-pool.png": "6150",
  "./recall/icon-progress-active.png": "966",
  "./recall/icon-progress.png": "9965",
  "./recall/icon-record-active.png": "7240",
  "./recall/icon-record.png": "6987",
  "./recall/icon-task-active.png": "4504",
  "./recall/icon-task.png": "1947",
  "./recall/invite_code_bg.png": "1303",
  "./recall/lmb.png": "5493",
  "./recall/lottery_btn_bg.png": "6630",
  "./recall/modal_btn.png": "5878",
  "./recall/panel-bg.png": "5656",
  "./recall/panel_menu_bg.png": "3770",
  "./recall/pool-reward-bg.png": "6176",
  "./recall/progress_bar.png": "3941",
  "./recall/progress_bg.png": "1441",
  "./recall/progress_divider.png": "3473",
  "./recall/progress_pointer.png": "7861",
  "./recall/record_split.png": "1352",
  "./recall/record_tabs_bg_left.png": "3616",
  "./recall/record_tabs_bg_right.png": "8053",
  "./recall/record_title_underline.png": "4755",
  "./recall/reward-modal-prize-name-bg-mini.png": "4598",
  "./recall/reward-modal-prize-name-bg.png": "8348",
  "./recall/share-base.png": "2623",
  "./recall/share_btn.png": "3064",
  "./recall/share_modal_bg.png": "2578",
  "./recall/share_modal_plater_bg.png": "6298",
  "./recall/simple-modal-bg.png": "3542",
  "./recall/split.png": "7116",
  "./recall/tab_active_item_bg.png": "6080",
  "./recall/tab_divider.png": "3219",
  "./recall/tab_item_bg.png": "4981",
  "./recall/task-reward-bg.png": "2253",
  "./recall/task_bg.png": "1311",
  "./recall/task_btn.png": "944",
  "./recall/task_btn_finished.png": "9775",
  "./recall/task_text_underline.png": "5874",
  "./recall/uid_bg.png": "2734",
  "./share/download.png": "6254",
  "./share/facebook.png": "3934",
  "./share/link.png": "7622",
  "./share/qq.png": "4236",
  "./share/qzone.png": "3139",
  "./share/weibo.png": "544",
  "./share/x.png": "1984",
  "./skills/bg.png": "960",
  "./skills/choose_icon.png": "5920",
  "./skills/choosed_bg.png": "324",
  "./skills/choosed_bg_2.png": "1695",
  "./skills/download_icon.png": "4253",
  "./skills/empty.png": "9210",
  "./skills/skill1.png": "7293",
  "./skills/skill1_use.png": "9137",
  "./skills/skill2.png": "1145",
  "./skills/skill2_use.png": "9490",
  "./skills/skill3.png": "8623",
  "./skills/skill3_use.png": "699",
  "./skills/skill4.png": "2752",
  "./skills/skill4_use.png": "6788",
  "./skills/skill5.png": "8505",
  "./skills/skill5_use.png": "7013",
  "./skills/skill_bottom.png": "6722",
  "./skills/tip.png": "1830",
  "./skills/tip_arrow.png": "2832",
  "./skills/tip_top.png": "4714",
  "./skills/title.png": "4019"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 5298;
